// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2c4cb651","50":"90a30d18","555":"6ec151c1","787":"56441b51"}[chunkId] + ".chunk.js";
};